import type { Ref } from 'vue';
import type { ProductAttributeFilterInput } from '~~/lib/Shop/generated/schema';

/**
 * TODO: move to explicit pdpConfiguration package with all function from
 *  '~/utils/shop/createSpecifications
 */
export type PdpConfiguration = {
  defaultConfiguration: StoreConfiguration;
  configurationByLocale: Record<string, StoreConfiguration>;
  localeCartCookieDomainMap: Record<string, string> & { default: string };
  localeStoreMap: Record<string, string>;
  variables: Record<string, string>;
  attributeSets: Record<string, number>;
  productCompareCategories: Array<{ id: number; name: string }>;
  relatedProductMapping: Record<
    string,
    Array<{
      dictionary?: string;
      sets: string[];
      filter?: ProductAttributeFilterInput;
    }>
  >;
};

type StoreConfiguration = {
  shoppingCartUrl: string;
  requestCartUrl: string;
  baseUrl: string;
};

/**
 * This composable relies on {@link useNuxtApp}.
 */
export function usePdpConfiguration(): Readonly<
  Ref<PdpConfiguration | undefined>
> {
  const { $globalPageSettings } = useNuxtApp();

  return computed(() => {
    if (!$globalPageSettings.value) {
      return;
    }

    return {
      defaultConfiguration: {
        shoppingCartUrl: '',
        requestCartUrl: '',
        baseUrl: ''
      },
      configurationByLocale: {},
      localeCartCookieDomainMap: {
        default: ''
      },
      localeStoreMap: {},
      relatedProductMapping: {},
      productCompareCategories: [],
      attributeSets: {},
      variables: {},
      ...($globalPageSettings.value?.shopConfig?.pdpConfiguration ?? {}),
      ...($globalPageSettings.value?.shopConfig?.pdpConfigurationVariables ??
        {})
    };
  });
}
